// =====================================================
// Gallery.jsx – Product selector, thumbnails, big preview
// =====================================================

import React, { useEffect, useState } from "react";
import styles from "../assets/styles/Gallery.module.css";
import axios from "axios";
import { FaTimes } from "react-icons/fa";

function Gallery() {
  const username = localStorage.getItem("username");

  const [products, setProducts] = useState([]); // dropdown list
  const [selectedProduct, setSelectedProduct] = useState("");
  const [images, setImages] = useState([]); // thumbnails
  const [largeImg, setLargeImg] = useState(null); // modal img

  /* ---------- load product folder names ---------- */
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          `http://localhost:5000/api/products/${username}`
        ); // expects { products: [] }
        setProducts(res.data.products || []);
      } catch (e) {
        console.error("Product list load error:", e);
      }
    };
    if (username) fetchProducts();
  }, [username]);

  /* ---------- load images when product changes ---------- */
  useEffect(() => {
    if (!selectedProduct) return;
    const fetchImages = async () => {
      try {
        const res = await axios.get(
          `http://localhost:5000/api/images/${username}/${selectedProduct}`
        ); // expects { files: [] }
        setImages(res.data.files || []);
      } catch (e) {
        console.error("Image list error:", e);
      }
    };
    fetchImages();
  }, [username, selectedProduct]);

  /* ---------- helpers ---------- */
  const imgUrl = (file) =>
    `http://localhost:5000/api/image/${username}/${selectedProduct}/${file}`;

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Gallery</h2>

      {/* ---------- product dropdown ---------- */}
      <label className={styles.label}>Select Product</label>
      <select
        className={styles.select}
        value={selectedProduct}
        onChange={(e) => setSelectedProduct(e.target.value)}
      >
        <option value="">-- choose --</option>
        {products.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
      </select>

      {/* ---------- thumbnails grid ---------- */}
      {selectedProduct && (
        <>
          {images.length === 0 ? (
            <p className={styles.noImages}>No images for this product.</p>
          ) : (
            <div className={styles.grid}>
              {images.map((file) => (
                <img
                  key={file}
                  src={imgUrl(file)}
                  alt={file}
                  className={styles.thumb}
                  onClick={() => setLargeImg(imgUrl(file))}
                />
              ))}
            </div>
          )}
        </>
      )}

      {/* ---------- modal for large view ---------- */}
      {largeImg && (
        <div className={styles.modalOverlay} onClick={() => setLargeImg(null)}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeBtn}
              onClick={() => setLargeImg(null)}
            >
              <FaTimes />
            </button>
            <img src={largeImg} alt="Large preview" className={styles.bigImg} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
